import { render, staticRenderFns } from "./OfficeCharts.vue?vue&type=template&id=6c5c81b0&"
import script from "./OfficeCharts.vue?vue&type=script&lang=js&"
export * from "./OfficeCharts.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports